"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = exports.StyledMenuItem = exports.StyledButton = void 0;
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styled_1 = __importDefault(require("@mui/material/styles/styled"));
exports.StyledButton = (0, mui_1.withStyles)(Button_1.default, ({ palette }) => ({
    root: {
        '&.MuiButton-outlined': {
            color: palette.gray6,
            WebkitTapHighlightColor: 'transparent',
            textTransform: 'none',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            fontSize: '1rem',
        },
        fontWeight: 400,
        border: `1px solid ${palette.gray5}`,
        '&:hover': {
            borderColor: palette.gray6,
        },
    },
}));
exports.StyledMenuItem = (0, styled_1.default)(MenuItem_1.default)({
    paddingLeft: '4px',
    paddingRight: '4px',
    display: 'flex',
    justifyContent: 'space-between',
});
exports.StyledTypography = (0, styled_1.default)(Typography_1.default)({
    paddingLeft: '8px',
    paddingRight: '8px',
    textAlign: 'left',
});
